function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Coordinate from '../geom/Coordinate';
import RobustLineIntersector from './RobustLineIntersector';
import Envelope from '../geom/Envelope';
var RectangleLineIntersector = /*#__PURE__*/function () {
  function RectangleLineIntersector() {
    _classCallCheck(this, RectangleLineIntersector);
    RectangleLineIntersector.constructor_.apply(this, arguments);
  }
  return _createClass(RectangleLineIntersector, [{
    key: "intersects",
    value: function intersects(p0, p1) {
      var segEnv = new Envelope(p0, p1);
      if (!this._rectEnv.intersects(segEnv)) return false;
      if (this._rectEnv.intersects(p0)) return true;
      if (this._rectEnv.intersects(p1)) return true;
      if (p0.compareTo(p1) > 0) {
        var tmp = p0;
        p0 = p1;
        p1 = tmp;
      }
      var isSegUpwards = false;
      if (p1.y > p0.y) isSegUpwards = true;
      if (isSegUpwards) {
        this._li.computeIntersection(p0, p1, this._diagDown0, this._diagDown1);
      } else {
        this._li.computeIntersection(p0, p1, this._diagUp0, this._diagUp1);
      }
      if (this._li.hasIntersection()) return true;
      return false;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return RectangleLineIntersector;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);
}();
export { RectangleLineIntersector as default };
RectangleLineIntersector.constructor_ = function () {
  this._li = new RobustLineIntersector();
  this._rectEnv = null;
  this._diagUp0 = null;
  this._diagUp1 = null;
  this._diagDown0 = null;
  this._diagDown1 = null;
  var rectEnv = arguments[0];
  this._rectEnv = rectEnv;
  this._diagUp0 = new Coordinate(rectEnv.getMinX(), rectEnv.getMinY());
  this._diagUp1 = new Coordinate(rectEnv.getMaxX(), rectEnv.getMaxY());
  this._diagDown0 = new Coordinate(rectEnv.getMinX(), rectEnv.getMaxY());
  this._diagDown1 = new Coordinate(rectEnv.getMaxX(), rectEnv.getMinY());
};